var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xx-select',_vm._g(_vm._b({staticClass:"tree-select",attrs:{"list":_vm.list},on:{"change":_vm.change},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'xx-select',_vm.attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }